import {
    createHandlerChainRunner,
    Handler,
    HandlerProps,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import {
    getProductCategories,
    ProductCategoriesModel,
    ProductCategoriesParameter,
} from "@tggstore/Services/CommonServices";

type Parameter = ProductCategoriesParameter & HasOnSuccess<ProductCategoriesModel[]>;

type Props = {
    apiResult: ProductCategoriesModel[];
    apiParameter: ApiParameter;
};

type HandlerType = Handler<Parameter, Props>;

const dispatchIsLoading = (isLoading: boolean, props: HandlerProps<Parameter, Props>) => {
    props.dispatch({
        type: "Custom/ProductCategoriesState/Loading",
        isLoading,
    } as any);
};

export const SetLoadingTrue: HandlerType = props => {
    dispatchIsLoading(true, props);
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        const result = await getProductCategories({
            productIds: props.parameter.productIds,
            type: props.parameter.type,
        });

        if (result.successful) {
            props.apiResult = result.result;

            props.dispatch({
                type: "Custom/ProductCategoriesState/ProductProperties",
                productProperties: result.result,
            } as any);
        } else {
            throw new Error(result.errorMessage);
        }
    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 404)) {
            props.dispatch({
                type: "Custom/ProductCategoriesState/FailedToLoad",
                countries: [],
                message: "Failed to load product categories",
            } as any);
            return false;
        }
        throw error;
    }
};

export const SetLoadingFalse: HandlerType = props => {
    dispatchIsLoading(false, props);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [SetLoadingTrue, RequestDataFromApi, SetLoadingFalse, ExecuteOnSuccessCallback];

const loadProductCategories = createHandlerChainRunner(chain, "LoadProductCategories");
export default loadProductCategories;
